export enum RoutesSlugs {
  BOOKING_DETAIL = "detail",
  BOOKINGS = "bookings",
  BOOKINGS_NEW = "bookings/add",
  CHECKOUT = "checkout",
  COMPLETE_PROFILE = "complete-profile",
  CONFIG = "config",
  CONTACT = "contact",
  EDIT_PROFILE = "edit-profile",
  EXAMPLE_HOME = "example-home",
  EXAMPLE_MATCH = "match-example",
  SHARED_STATISTICS = "shared-statistics",
  EXAMPLE_MATCH_COMPARE = "match-compare-example",
  FAKE_SECTIONS = "fake-sections",
  HOME = "",
  HOMEPAGE = "homepage",
  LOGIN = "login",
  LOGOUT = "logout",
  MATCH = "match",
  MATCH_COMPARE = "compare",
  NOTIFICATIONS = "notifications",
  NO_INTERNET = "no-internet",
  ONBOARDING = "onboarding",
  PAYMENT_MISSING = "payment-missing",
  MATCH_DETAIL = "detail",
  PLAYER_IDENTIFICATION = "player-identification",
  PLAYER_IDENTIFICATION_V2 = "player-identification-v2",
  WALLET = "wallet",
  REGISTER = "register",
  REGISTRATION_SUCCESS = "registration-success",
  RESET_PASSWORD = "reset-password",
  VERIFY_EMAIL = "verify-email",
  APP_SETTINGS = "app-settings",
  FEEDBACK = "feedback",
  COMMUNITY = "community",
  STATISTICS = "statistics",
  EVOLUTION = "evolution",
  TEST_COMPONENTS = "test-components",
  ADMIN_IMPERSONATE = "admin-impersonate",
  COMING_SOON_CHAT = "coming-soon-chat",
  COMING_SOON_OPEN = "coming-soon-open",
}
